import { Spinner } from '@change/ds-core-ui/Spinner';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { withPrefetchedData } from '#src/shared/prefetch';

import { prefetchPageContext, StartAPetitionPageContextProvider } from '#src/app/pages/startAPetitionV2/pageContext';
import type { StartAPetitionPagePrefetchedDataProps } from '#src/app/pages/startAPetitionV2/pageContext';

import { Layout } from '../layout';

import { StartAPetitionErrorHandler } from './ErrorHandler';
import { StartAPetitionRedirectHandler } from './RedirectHandler';

export const EntryPoint = withPrefetchedData(
	function EntryPoint({ prefetchedData }: StartAPetitionPagePrefetchedDataProps) {
		return (
			<ClientRender>
				<StartAPetitionPageContextProvider
					prefetchedData={prefetchedData}
					errorHandler={StartAPetitionErrorHandler}
					redirectHandler={StartAPetitionRedirectHandler}
					loadingFallback={<Spinner className="mx-auto my-64" />}
				>
					<Layout />
				</StartAPetitionPageContextProvider>
			</ClientRender>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
	},
);
